import { apiClientAuth } from "../http/httpClient";


export function NotificationApi(contentType = "application/json")
{
    const https = apiClientAuth(contentType);

    return {


        // insert : (data) => https.post(`/api/folder`, data),

        // updateOne : (id, data) => https.put(`/api/folder/${id}`, data),

        // findAllByRepo: ( repositoryId ) => https.get(`/api/folder/repository/${repositoryId}`),

        // findOne: (id) => https.get(`/api/folder/${id}`),

        // deleteOne: (id) => https.delete(`/api/folder/${id}`),



        findAll: () => https.get(`/api/notification`),
        
    };
}
